import React from 'react';
import Helmet from 'react-helmet';
import { FooterLegal, GetInContact, Hr, NarrowPage } from '@sthzg/sthzgnet-branding';
import '../styles/global';

const ImpressumPage = () => (
  <NarrowPage>
    <Helmet>
      <title>Legal Notes | Impressum – sthzg.net</title>
      <meta
        name="description"
        content="Working on server side rendered websites with Node.JS and React. Enthusiastic about
        npm packaging, Webpack, CI-workflows and cloud deployments."
      />
    </Helmet>
    <h1>Legal Notes</h1>
    <Hr />
    <p>
      <b>Stephan Herzog</b>
      <br />
      Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik
    </p>
    <p>
      <b>Address</b>
      <br />
      Schelleingasse 21/13<br />
      1040 Vienna, Austria
    </p>
    <p>
      <b>Contact</b>
      <br />
      Phone: 0043.660.733 95 59<br />
      <a href="mailto:sthzgvie@gmail.com">sthzgvie@gmail.com</a>
    </p>
    <p>
      <b>Company</b>
      <br />
      Vat-ID: ATU72032178<br />
      GLN: 9110021822602<br />
      GISA: 27455029<br />
      Court of Registry: Handelsgericht Wien<br />
      Authority according to ECG: Magistratisches Bezirksamt für den 4. Bezirk<br />
      Registration Number: 08 364/4120
    </p>
    <p>
      <b>Profiles</b>
      <br />
      <a href="https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=2b2dfdcf-9b9c-4e27-8ab1-2b66f8260a46">
        WKO Profile
      </a>
    </p>
    <Hr />
    <GetInContact />
    <FooterLegal />
  </NarrowPage>
);

export default ImpressumPage;



// WEBPACK FOOTER //
// ./src/pages/impressum.jsx